import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/boas_vindas.svg'
import _imports_1 from '@/assets/icons/unauthorized.svg'


const _hoisted_1 = { class: "welcome-two-factor-content" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "Boas-vindas"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  height: "257px",
  alt: "Sem autenticação"
}
const _hoisted_4 = { class: "d-flex flex-column gap-2" }
const _hoisted_5 = {
  key: 0,
  class: "title"
}
const _hoisted_6 = {
  key: 1,
  class: "title2"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (!_ctx.$props.adminUser?.getFirstName())
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : (_openBlock(), _createElementBlock("img", _hoisted_3)),
      _createElementVNode("div", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"height":"var(--semantic-spacing-stack-300, 32px)"} }, null, -1 /* HOISTED */)),
        (!_ctx.$props.adminUser?.getFirstName())
          ? (_openBlock(), _createElementBlock("h1", _hoisted_5, "Boas Vindas!"))
          : (_openBlock(), _createElementBlock("h1", _hoisted_6, "Opa, você ainda não configurou a autenticação de 2 fatores!")),
        (!_ctx.$props.adminUser?.getFirstName())
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[1] || (_cache[1] = [
              _createElementVNode("p", { class: "sub-title" }, "Precisamos configurar sua senha e a autentificação de 2 fatores, para garantir a segurança da sua conta!", -1 /* HOISTED */),
              _createElementVNode("p", { class: "sub-title" }, [
                _createElementVNode("b", null, "Pronto pra começar?")
              ], -1 /* HOISTED */)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [
              _createElementVNode("p", { class: "sub-title" }, [
                _createTextVNode("É fundamental para "),
                _createElementVNode("b", null, "garantirmos segurança máxima do Foodpass da sua empresa!")
              ], -1 /* HOISTED */)
            ])))
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"height":"var(--semantic-spacing-stack-600, 48px)"} }, null, -1 /* HOISTED */)),
      _createVNode($setup["CommonButton"], {
        class: "w-100",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-initialize'))),
        text: _ctx.$props.adminUser?.getFirstName() ? 'Configurar autenticação' : 'Começar configuração'
      }, null, 8 /* PROPS */, ["text"])
    ])
  ]))
}